import React, {Fragment, useEffect, useState} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input} from 'reactstrap';
import {mapToCssModules} from "reactstrap/lib/utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";

import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";

const MySwal = withReactContent(Swal)

const FastChoiceChooseModal = (props) => {
    const {
        toggle,
        isOpen,
        constituents,
        setConstituents
    } = props;

    const [fastChoice, setFastChoices] = useState("");
    const [options, setOptions] = useState([]);
    const [validationFailed, setValidationFailed] = useState(false);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/all-fast-picks`).then((result) => {
            let picks = result.data.picks;
            let picksPrepared = picks.map((pick, index) => {
                return {
                    value: pick.name,
                    label: pick.name,
                    ids: pick.ids,
                    id: pick._id
                }
            });
            setOptions(picksPrepared);
        })
    }, [])


    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                Odaberi spremljeno
            </ModalHeader>
            <ModalBody>
                <Select
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    value={fastChoice}
                    styles={{
                        control: styles => ({
                            ...styles,
                            borderColor: (validationFailed && fastChoice === "") ? 'red' : styles.borderColor,
                            '&:hover': {
                                borderColor: (validationFailed && fastChoice === "") ? 'red' : styles['&:hover'].borderColor
                            }
                        })
                    }}
                    onChange={(data) => {
                        setFastChoices(data)
                    }}
                    name='clear'
                    options={options}
                    isClearable={false}
                />
            </ModalBody>
            <ModalFooter>
                <div className='row justify-content-center text-center' style={{width: "100%"}}>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            props.toggle();
                        }}
                                       type='submit'
                                       color='danger'
                                       className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odustani</span>
                        </Button.Ripple>
                    </div>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            if (fastChoice === "") {
                                setValidationFailed(true);
                                return;
                            }

                            let newChosenConstituents = constituents.map((constituent) => {
                                let idFound = false;
                                fastChoice.ids.map((id => {
                                    if (constituent.id === id) {
                                        idFound = true;
                                    }
                                }));
                                constituent.is_checked = idFound;
                                return constituent;
                            });
                            setConstituents(newChosenConstituents);

                            console.log(newChosenConstituents);

                            MySwal.fire({
                                icon: 'success',
                                title: 'Selekcija uspješna',
                                text: '',
                                customClass: {
                                    confirmButton: 'btn btn-success'
                                }
                            })
                            toggle();

                        }} type='submit' color='primary' className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odaberi</span>
                        </Button.Ripple>
                    </div>
                </div>
            </ModalFooter>
        </Modal>

    );
}

export default FastChoiceChooseModal;